import React, { useState, useEffect } from "react";
import Login from "../login";
import { Provider } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";

//Componentes
import ProtectedRoute from "../../utils/ProtectedRoute/ProtectedRoute";
import Container from "../container";
import HomeDesign from "../Home/home";
import GeneralMenu from "../../components/menu/GeneralMenu";
import VisualizadorSolicitudEmpleo from "../../screens/solicitudes/visualizadorSolicitudEmpleo";
import VisualizadorSolicitudEmpleoHistorico from "../../screens/solicitudesHistorico/visualizadorSolicitudEmpleo";
import VisualizadorAPEReclutamiento from "../../screens/reclutamiento/VisualizadorAPE";
import VisualizadorAPEContratacion from "../../screens/contratacion/VisualizadorAPE";
import Menu from "../../screens/solicitudes/menuOperaciones";
import GestionContratos from "../../screens/contratos/Prorrogas/VisualizadorDeProrrogas";
import PanelInfo from "../../components/panelInformacion";
import GestorReclutamiento from "../../screens/reclutamiento/GestorReclutamiento";
import GestorFechaContratacion from "../../screens/confirmacionFechaContratacion/GestorFechaContratacion";
import GestorCargaContrato from "../../screens/cargarContrato/GestorCargaContrato";
import GestorNomina from "../../screens/nomina/GestorNomina";
import GestorRetiro from "../../screens/retiro/GestorRetiro";
import GestionUsuarios from "../../screens/gestionUsuarios/ManageUsers";
import GestorContratacion from "../../screens/contratacion/GestorContratacion";
import ListadoHistorial from "../../screens/solicitudesHistorico/listadoHistorial";
import ConfirmarFechaContratacion from "../../screens/confirmacionFechaContratacion/PantallaConfirmacionFecha";
import CargarContrato from "../cargarContrato/PantallaCargarContrato";
import MailComposer from "../../screens/correos/mailComposer";
import GestionCorreos from "../../screens/correos/ManageMails";
import InformeAPE from "../../screens/InformeAPE/InformeAPE";
import reducer from "../../store/userGeneralInfo/userGeneralInfo";
import Loading from "../../components/modales/loadingModal";
import { Routes, Route, useNavigate } from "react-router-dom"; //API Calls
import { functionsHttpsCallable } from "../../utils/FirebaseStorage/firebase";
import { useLocation } from "react-router-dom";

//API Calls
const {
	apiConsultaKactus,
	apiGetAuthToken,
} = require("../../utils/APIs/APISResume");
const getInfoUser = functionsHttpsCallable("general_infoUsuario");

export default function App2() {
	const navigate = useNavigate();
	const location = useLocation();
	const [userData, setUserData] = useState({});
	const [userToken, setUserToken] = useState(undefined);
	const [codigoEmpresa, setCodigoEmpresa] = useState();
	const [signedIn, setSignedIn] = useState(false);
	const [loading, setLoading] = useState(false);
	const [userId, setUserId] = useState(undefined);
	const [menuVisible, setMenuVisible] = useState(false);
	const { user, isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
	useEffect(() => {
		if (!isAuthenticated && !isLoading) {
			navigate("/login");
		}
		if (isAuthenticated && !isLoading) {
			setUserId(user["http://localhost:3000/username"]);
		}
		async function getDataUsuarioFunction() {
			if (isAuthenticated && !isLoading && userId !== undefined) {
				setLoading(true);
				const userInfo = await getInfoUser({
					userId: userId,
				});
				const dataUsuario = await getDataUsuario(
					userInfo.data.data.codigoEmpresa
				);
				let token;
				try {
					token = await apiGetAuthToken();
				} catch (error) {
					console.log("error token", error);
				}

				setCodigoEmpresa(userInfo.data.data.codigoEmpresa);
				setUserToken(token ? token.token : "");
				setUserData({ ...dataUsuario });
				setLoading(false);
			}
		}
		getDataUsuarioFunction();
	}, [userId, isLoading, isAuthenticated]);

	useEffect(() => {
		if (
			user !== undefined &&
			codigoEmpresa !== undefined &&
			userData !== undefined
		)
			updateReducer(userData);
	}, [user, codigoEmpresa, userData]);

	const toggleMenu = () =>
		setMenuVisible((prevMenuVisible) => !prevMenuVisible);

	const getDataUsuario = async (codigoEmpresa1) => {
		let body = {
			cod_empl: userId,
			cod_empr: `${codigoEmpresa1}`,
		};
		let userData = await apiConsultaKactus(body);
		return userData;
	};

	const returnTextFormated = (text) => {
		try {
			let newText = text.split(" ");
			let returnText = "";
			newText.forEach((word, index) => {
				if (word !== "") {
					if (index > 0) {
						returnText = returnText + " " + word;
					} else {
						returnText = word;
					}
				}
			});
			return returnText;
		} catch (error) {
			console.log("error", error);
			return text;
		}
	};

	const returnRolesList = (roles) => {
		let arrayRoles = roles.split(",");
		return arrayRoles;
	};

	const updateReducer = (data) => {
		const val = Object.keys(data).length > 0;
		let userData = {
			userId: user["http://localhost:3000/username"],
			token: userToken,
			email: user.email,
			user: user,
			codigoEmpresa: codigoEmpresa,
			nombre: val
				? returnTextFormated(`${data[0].nom_empl} ${data[0].ape_empl}`)
				: "SinNombre",
			roles: user["http://localhost:3000/roles"],
			gerencia: val ? returnTextFormated(data[0].fol_cont) : "Sin Gerencia",
			cargo: val ? returnTextFormated(data[0].nom_carg) : "Sin Cargo",
		};
		localStorage.setItem("userData", JSON.stringify(userData));
		reducer.dispatch({
			type: "LOG_IN",
			userData: userData,
		});
	};
	return (
		<div>
			{loading || isLoading ? (
				<Loading />
			) : (
				<Provider store={reducer}>
					<Container
						signedIn = {signedIn}
						setSignedIn = { (e) => { setSignedIn(e); } }
						name = {
							Object.keys(userData).length > 0
								? userData[0].nom_empl.split(" ")[0]
								: ""
						}
						toggleMenu={() => toggleMenu()}
						menuVisible={menuVisible}
						currentPath={location.pathname}
					>
						<div className="app-inner-layout rm-sidebar container-panels">
							<div className="app-inner-layout__wrapper container-1">
								<div className="app-inner-layout__content">
									<div className="app-header-menu">
										<GeneralMenu
											setMenuVisible={(e) => setMenuVisible(e)}
											menuVisible={menuVisible}
											userData={userData}
										/>
									</div>
									<div className="he-100 right-panel">
										<Routes>
											<Route
												path="/*"
												element={
													<Login
														setSignedIn={(e) => {
															setSignedIn(e);
														}}
													/>
												}
											/>
											<Route
												path="/home//*"
												element={<HomeDesign userData={userData} />}
											/>
											<Route
												path="/home/usuario"
												element={<PanelInfo userData={userData} />}
											/>
											<Route path="/home/procesos" element={<Menu />} />
											<Route
												path="/home/prorrogas"
												element={<GestionContratos />}
											/>
											<Route path="/home/nomina" element={<GestorNomina />} />
											<Route
												path="/home/usuarios"
												element={<GestionUsuarios />}
											/>
											<Route path="/home/retiros" element={<GestorRetiro />} />
											<Route
												path="/home/proceso-seleccion"
												element={<GestorReclutamiento />}
											/>
											<Route
												path="/home/proceso-contratacion"
												element={<GestorContratacion />}
											/>
											<Route
												path="/home/historico"
												element={<ListadoHistorial />}
											/>
											<Route
												path="/home/historico/solicitud/:id"
												element={<VisualizadorSolicitudEmpleoHistorico />}
											/>
											<Route
												path="/home/solicitud/:id"
												element={<VisualizadorSolicitudEmpleo />}
											/>
											<Route
												path="/home/mail-composer"
												element={<MailComposer />}
											/>
											<Route
												path="/home/mail-manager"
												element={<GestionCorreos />}
											/>
											<Route
												path="/home/procesoseleccion/ape/:id"
												element={<VisualizadorAPEReclutamiento />}
											/>
											<Route
												path="/home/proceso-contratacion/ape/:id"
												element={<VisualizadorAPEContratacion />}
											/>
											<Route
												path="/home/fechaContratacion"
												element={<ConfirmarFechaContratacion />}
											/>
											<Route
												path="/home/confirmarFechaContratacion"
												element={<GestorFechaContratacion />}
											/>
											<Route
												path="/home/cargarContrato"
												element={<CargarContrato />}
											/>
											<Route
												path="/home/cargueContrato"
												element={<GestorCargaContrato />}
											/>
											<Route
												path="/home/informe-ape"
												element={<InformeAPE />}
											/>
										</Routes>
									</div>
								</div>
							</div>
						</div>
					</Container>
				</Provider>
			)}
		</div>
	);
}
